import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IncWaitPage from 'components/inc-wait-page/inc-wait-page.component';

const PasswordlessAuthentication = () => {
  const { t } = useTranslation();

  return (
    <IncWaitPage helmetTitle={t('passwordless.magicLinkAuthentication.title')}>
      <Typography>
        {t('passwordless.magicLinkAuthentication.pleaseWait1')}
      </Typography>
      <Typography variant="body2">
        {t('passwordless.magicLinkAuthentication.pleaseWait2')}
      </Typography>
    </IncWaitPage>
  );
};

export default PasswordlessAuthentication;
